import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { FetchToken, AuthGuard, IsOtherDomain } from './shared/services/auth-guard.service';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { CalendarEventFilesComponent } from './calendar-event-files/calendar-event-files.component';
import { RecruiterRescheduleComponent } from './recruiter-reschedule/recruiter-reschedule.component';
import { RecruiterCancelComponent } from './recruiter-cancel/recruiter-cancel.component';
import { CustomDomainResolve } from './slots/slots.resolve';
import { SlotsComponent } from './slots/slots.component';
import { CustomDomainRedirectComponent } from './custom-domain-redirect/custom-domain-redirect.component';

const appRoutes: Routes = [
    // { path: '', redirectTo:'auth/login', pathMatch:'full' },
    // { path: 'auth', loadChildren: './auth/auth.module#AuthModule' },
    
    { path: '', redirectTo:'appointment' ,pathMatch:"full"},
    {path : 'recruiter/reschedule' , component : RecruiterRescheduleComponent},
    {path : 'recruiter/cancel', component : RecruiterCancelComponent},
    { path: 'appointment', loadChildren: './appointments/appointments.module#AppointmentsModule', canActivate:[FetchToken] },
    { path: "CalendarEventFiles", component: CalendarEventFilesComponent },
    {
        path: ':id', component: CustomDomainRedirectComponent, resolve: { customDomainData: CustomDomainResolve }, canActivate: [IsOtherDomain]
    },
    { path: 'unauthorized', component: UnauthorizedComponent }
    
    
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts